import React from "react"

const Facebook = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.0001 1.69995C5.41675 1.69995 1.66675 5.44162 1.66675 10.05C1.66675 14.2166 4.71675 17.6749 8.70008 18.2999V12.4666H6.58342V10.05H8.70008V8.20828C8.70008 6.11662 9.94175 4.96662 11.8501 4.96662C12.7584 4.96662 13.7084 5.12495 13.7084 5.12495V7.18328H12.6584C11.6251 7.18328 11.3001 7.82495 11.3001 8.48328V10.05H13.6168L13.2418 12.4666H11.3001V18.2999C13.2638 17.9898 15.0519 16.9879 16.3417 15.475C17.6315 13.9621 18.3379 12.038 18.3334 10.05C18.3334 5.44162 14.5834 1.69995 10.0001 1.69995Z"
        fill="white" />
    </svg>
  )
}

export default Facebook
